// referenzen_karten — dark slide, three mandate-reference cards (v15 slide 10): mood image,
// white logo chip, mono context label, serif claim, body, and the gold «Was hier zählt» line
// (takeaway — the per-deck override is already applied by the bound resolver).
import type { ReferenzenBound, ReferenzenKartenContent } from '../../../../shared/deckTypes.js';
import { Abs, Brand, Dkp, Eyebrow, PageNo, Rule } from './chrome.js';

const CARD_X = [64, 464, 864];
const CARD_W = 352;

export default function ReferenzenKartenPreview({ content, bound, pageNo }: {
  content: ReferenzenKartenContent;
  bound?: ReferenzenBound;
  pageNo?: number | null;
}) {
  const c = content;
  const cards = (bound?.cards ?? []).slice(0, 3);

  return (
    <Dkp variant="dark">
      <Eyebrow text={c.eyebrow ?? ''} />
      <Abs x={64} y={84} w={1112}>
        <div className="dkp-title" style={{ color: '#F3F1EC' }}>{c.title}</div>
      </Abs>

      {cards.map((card, i) => {
        const x = CARD_X[i];
        return (
          <div key={card.id}>
            {card.moodImageKey ? (
              <Abs x={x} y={196} w={CARD_W} h={150}>
                <img src={card.moodImageKey} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </Abs>
            ) : (
              <Abs x={x} y={196} w={CARD_W} h={150} style={{ background: '#111317' }} />
            )}
            {/* the white logo chip riding the image's lower edge */}
            {card.logoKey ? (
              <Abs x={x + 14} y={322} style={{
                background: '#FFFFFF', borderRadius: 6, padding: '8px 12px', lineHeight: 0,
              }}>
                <img src={card.logoKey} alt="" style={{ height: 32, maxWidth: 96, objectFit: 'contain' }} />
              </Abs>
            ) : null}
            <Abs x={x} y={384} w={CARD_W}>
              <span className="dkp-mono" style={{
                fontSize: 9.3, letterSpacing: '.11em', textTransform: 'uppercase', color: '#9A9DA3',
              }}>{card.contextLabel}</span>
            </Abs>
            {/* claim + body flow together (v15 sets the body right under the wrapped claim) */}
            <Abs x={x} y={403} w={CARD_W} h={192} style={{ overflow: 'hidden' }}>
              <div className="dkp-serif" style={{ fontSize: 18.7, lineHeight: 1.3, color: '#F3F1EC', marginBottom: 10 }}>
                {card.claim}
              </div>
              <div style={{ fontSize: 12, fontWeight: 500, color: '#D9D6CF', lineHeight: 1.5 }}>
                {card.body}
              </div>
            </Abs>
            <Abs x={x} y={600} w={CARD_W}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#E2C990', lineHeight: 1.45 }}>
                Was hier zählt: {card.takeaway}
              </div>
            </Abs>
          </div>
        );
      })}

      <Rule x={64} y={663} w={1152} color="#3A3C41" />
      {c.footer_line ? (
        <Abs x={340} y={674} w={600} style={{ textAlign: 'center' }}>
          <span className="dkp-serif" style={{ fontSize: 16, color: '#E2C990' }}>{c.footer_line}</span>
        </Abs>
      ) : null}

      <Brand light />
      <PageNo n={pageNo} light />
    </Dkp>
  );
}
